import { render, staticRenderFns } from "./UIPortfoliosDropdown.vue?vue&type=template&id=4185dacc"
import script from "./UIPortfoliosDropdown.vue?vue&type=script&lang=js"
export * from "./UIPortfoliosDropdown.vue?vue&type=script&lang=js"
import style0 from "./UIPortfoliosDropdown.vue?vue&type=style&index=0&id=4185dacc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports